export default {
  category: 'book',
  name: 'Total Money Makeover',
  author: 'Dave Ramsey',
  date: '5/4/25',
  path: '/notes/total-money-makeover',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-total-money-makeover-dave-ramsey.jpg',
  tags: ['Finance', 'Money', 'Business'],
  time: 33,
  rating: 8.8,
  review: '',
  link: 'https://www.amazon.com/Total-Money-Makeover-Classic-Financial/dp/1595555277',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.twosapp.com/6807c16df8f43d65a1009284',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
